import axios from "axios";
import {mapDataToFormData} from "../helpers/ajax";

export default class LicenseApi {

    deactivateUrl(key: string, url: string) {
        return axios.post('/', mapDataToFormData({
            command: 'deactivate',
            activation_key: key,
            activation_url: 'https:' + url
        }));
    }

}